import { render, staticRenderFns } from "./reviewWidgetBadge.vue?vue&type=template&id=54e81252&"
import script from "./reviewWidgetBadge.vue?vue&type=script&lang=js&"
export * from "./reviewWidgetBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vasile_cyt/Documents/plentyDevTool/25996/21/reviewWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e81252')) {
      api.createRecord('54e81252', component.options)
    } else {
      api.reload('54e81252', component.options)
    }
    module.hot.accept("./reviewWidgetBadge.vue?vue&type=template&id=54e81252&", function () {
      api.rerender('54e81252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/reviewWidgetBadge.vue"
export default component.exports